var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcUserCheck = function SvgIcUserCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.75 17.75-.937-.937a.442.442 0 0 1 .598-.651l.614.517a1.317 1.317 0 0 0 1.828-.127l3.162-3.513a.689.689 0 1 1 .998.948L16.25 17.75c-.69.69-1.81.69-2.5 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.444 7.778A2.652 2.652 0 0 0 11.8 5.133a2.652 2.652 0 0 0-2.644 2.645 2.652 2.652 0 0 0 2.644 2.644 2.652 2.652 0 0 0 2.644-2.644Zm-6.422 0C8.022 5.7 9.722 4 11.8 4c2.078 0 3.778 1.7 3.778 3.778 0 2.078-1.7 3.778-3.778 3.778a3.789 3.789 0 0 1-3.778-3.778Zm8.49 6.71a3.392 3.392 0 0 0-2.445-1.044H9.533a3.41 3.41 0 0 0-3.4 3.4v1.89c0 .623.51 1.133 1.134 1.133h9.066c.624 0 1.134-.51 1.134-1.134v-.872l1.133-.944v1.816A2.273 2.273 0 0 1 16.333 21H7.267A2.273 2.273 0 0 1 5 18.733v-1.889a4.547 4.547 0 0 1 4.533-4.533h4.534c1.269 0 2.42.529 3.245 1.377l-.8.8Z",
    fill: "currentColor"
  })));
};
export default SvgIcUserCheck;